import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormattedMessage } from "react-intl";
import { ButtonToolbar } from "react-bootstrap";
import { DataTable } from "../../../common/DataTable";

import MONTHS from "./enums/months";
import SuppliersReportsFilter from "./SuppliersReportsFilter";
import { DownloadS3Button } from "../../../common";
import { SUPPLIERS_REPORTS } from "../../../../utils/data/models";
import * as dataActions from "../../../../utils/data/dataActions";
import englishTranslations from "../../../../components/intl/en-CA";
import frenchTranslations from "../../../../components/intl/fr-CA";
import { canDownload } from "../../../common/CanDownload";

class SuppliersReportsDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.getData = this.getData.bind(this);
    this.onDownloaded = this.onDownloaded.bind(this);
    this.buildDescription = this.buildDescription.bind(this);
    this.updateSupplierReportFilters = this.updateSupplierReportFilters.bind(
      this
    );

    this.state = {
      filters: props.filters,
    };
  }

  componentWillMount() {
    this.props.dataActions
      .getDataList(
        SUPPLIERS_REPORTS,
        0,
        50,
        undefined,
        ["month:desc"],
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      )
      .then((v) => {
        this.data = v.payload.data.items;
        this.getData(
          this.props.offset,
          this.props.limit,
          this.props.q,
          this.props.sortBy,
          [`reports.year=='${new Date().getFullYear()}'`],
          true
        );
      });
  }

  getCols() {
    return [
      {
        name: (
          <FormattedMessage id="suppliersReports.datatable.columns.month" />
        ),
        display: (report) => (
          <span>
            <FormattedMessage
              id={MONTHS.find((m) => m.value == report.month).key}
            />
          </span>
        ),
        widthPct: 60,
      },
      {
        name: <FormattedMessage id="suppliersReports.datatable.columns.size" />,
        display: (report) => (
          <span>{`${Math.round(report.size / 1000)}`} ko</span>
        ),
        widthPct: 20,
      },
      {
        name: (
          <FormattedMessage id="suppliersReports.datatable.columns.actions" />
        ),
        display: (report) => this.generateActionButtons(report),
        widthPct: 20,
      },
    ];
  }

  buildDescription(report){
    let createdAtDate = report.createdAt.split("T")[0];
    let fileName = report.objectName;

    const userLanguage = localStorage.getItem("languageCode") || "en-CA";
    if(userLanguage == "fr-CA"){
      return frenchTranslations.downloader.suppliersReports + ":\n" + createdAtDate + " - " + fileName;
    }
    return englishTranslations.downloader.suppliersReports + ":\n" + createdAtDate + " - " + fileName;
  }

  generateActionButtons(report) {
    let description = this.buildDescription(report);

    return (
      <ButtonToolbar key={report.reportId}>
        <DownloadS3Button
          model={SUPPLIERS_REPORTS}
          disabled={!canDownload(description, this.props.currentDownloads)}
          attachment={report}
          identifier={description}
          label={<FormattedMessage id="common.download" />}
          onDownloaded={this.onDownloaded}
        />
      </ButtonToolbar>
    );
  }

  onDownloaded(report) {
    
    this.props.dataActions.getDataItem(SUPPLIERS_REPORTS, report.reportId);
  }

  updateSupplierReportFilters(fields) {
    const filters = [`reports.year=='${fields.supplierReportsFilter}'`];
    this.setState({ filters: fields.supplierReportsFilter });

    this.getData(
      this.props.offset,
      this.props.limit,
      this.props.q,
      this.props.sortBy,
      filters,
      true
    );
  }

  generateFilterButton() {
    if (!this.data) return;
    const currentYear = new Date().getFullYear();
    const yearList = this.data.map((i) => i.year);
    const options = [...new Set(yearList)].map((year) => {
      return { text: year, value: year };
    });

    return (
      <SuppliersReportsFilter
        initialValues={{ supplierReportsFilter: currentYear }}
        onChange={this.updateSupplierReportFilters}
        options={options}
      />
    );
  }

  getData(offset, limit, q, sortBy, filters, extraFilters = {}) {
    const additionalParams = { ...this.state.extraFilters, ...extraFilters };
    return this.props.dataActions.getDataList(
      SUPPLIERS_REPORTS,
      offset,
      limit,
      undefined,
      sortBy,
      filters,
      undefined,
      undefined,
      undefined,
      undefined,
      additionalParams
    );
  }

  render() {
    return (
      <DataTable
        ref="dataTable"
        getData={this.getData}
        cols={this.getCols()}
        filters={this.props.filters}
        offset={this.props.offset}
        data={this.props.items}
        rowsPerPage={this.props.limit}
        rowHeight={56}
        totalRows={0}
        filterButtons={this.generateFilterButton()}
        sortBy={this.props.sortBy}
      />
    );
  }
}

SuppliersReportsDataTable.propTypes = {
  auth: PropTypes.object,
  dataActions: PropTypes.object,
  filters: PropTypes.array,
  limit: PropTypes.number,
  offset: PropTypes.number,
  sortBy: PropTypes.array,
  total: PropTypes.number,
  items: PropTypes.array,
  currentDownloads: PropTypes.array,
  q: PropTypes.string,
};

function mapStateToProps(state) {
  const data = state.data.reports || {};
  const pagination = data.pagination || {};
  const downloads = state.downloader;

  return {
    filters: data.filters,
    limit: pagination.limit || 100,
    q: data.q,
    offset: pagination.offset || 0,
    sortBy: data.sortBy || ["month:desc"],
    total: pagination.totalCount || 0,
    items: data.items || null,
    currentDownloads: downloads.files || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuppliersReportsDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/suppliersReports/SuppliersReportsDataTable.js